import messages from "i18n/messages";
import first from "lodash/first";
import sortBy from "lodash/sortBy";
import flowRight from "lodash/flowRight";
import truncate from "lodash/truncate";
import { makeSelectDatesByEventId } from "logic/dates";
import { makeSelectCurOrg } from "logic/orgs";
import moment from "moment";
import Link from "next/link";
import { Component } from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Skeleton } from "./index";
import DefaultBg from "../assets/img/default-bg.png";

const EventImg = ({ event, children }) => {
  const image =
    event && event.images && event.images.length > 0
      ? first(event.images)
      : null;
  const imgDesc =
    image && (image.description || image.copyright)
      ? `${image.description}${
          image.description && image.description.length > 0 ? " - " : ""
        }Copyright: ${image.copyright}`
      : null;

  return (
    <div
      className="event-img"
      style={{
        backgroundImage: `url(${
          event && event.images && event.images.length > 0
            ? first(event.images).full
            : DefaultBg
        }`,
      }}
      title={imgDesc}
    >
      {children}
    </div>
  );
};

class EventCardItem extends Component {
  render() {
    const { dates, event, org } = this.props;
    let date = sortBy(dates, "starts_at").find(
      (d) => !d.sold_out && !d.cancelled
    );
    let cancelled;
    if (!date) cancelled = sortBy(dates, "starts_at").find((d) => !d.sold_out);
    let cancelledText =
      cancelled && cancelled.cancelled ? "cancelled" : "soldOut";
    if (cancelledText === "cancelled" && process.env.HZL_INST)
      cancelledText = "dateNotAvailable";
    const starts_at = date ? moment(date.starts_at) : null;
    const eventLink = `/${org.odn}/e/${event.id}`;
    const dateFlags = { month: "short", day: "numeric" };
    if (!date || !date.all_day) {
      dateFlags["hour"] = "numeric";
      dateFlags["minute"] = "numeric";
    }
    return (
      <div className="col-md-6 col-lg-4 p-0 col-sm-12 col-xs-12">
        <div className="event-card-item">
          <EventImg event={event}>
            {date && dates.length === 1 ? (
              <Link href={`/${org.odn}/b/${date.id}`}>
                <button className="on-sale-date btn">
                  <FormattedMessage {...messages.tickets} />
                </button>
              </Link>
            ) : null}
            {date && dates.length > 1 ? (
              <Link href={`/${org.odn}/b/${date.id}`}>
                <button className="on-sale-date btn">
                  <FormattedMessage {...messages.onSale} />
                  :&nbsp;&nbsp;
                  {starts_at ? (
                    <FormattedDate value={starts_at} {...dateFlags} />
                  ) : null}
                </button>
              </Link>
            ) : null}
            {!date ? (
              <button className="on-sale-date btn">
                <FormattedMessage {...messages[cancelledText]} />
              </button>
            ) : null}
          </EventImg>
          <div className="event-card-body">
            <h4 className="event-title">
              <div>{event ? event.title : <Skeleton />}</div>
            </h4>
            <div className="event-subtitle">
              {event ? truncate(event.subtitle, { length: 40 }) : <Skeleton />}
            </div>
            <div className="location">
              <h5>{date ? date.location_name : <span className="mr-1" />}</h5>
              <p>{date ? date.location_addr : <span className="mr-1" />}</p>
            </div>
          </div>
          <div className="event-card-footer">
            <div className="d-flex justify-content-right pt-3">
              <button className="btn btn-outline-primary btn-icon" disabled>
                <span className="tt-icon tt-icon-network-connection" />
              </button>
              <button className="btn btn-outline-primary btn-icon" disabled>
                <span className="tt-icon tt-icon-favorite-2" />
              </button>
              <Link href={eventLink}>
                <a href={eventLink} className="more-link">
                  <FormattedMessage {...messages.moreInformation} />
                  <span className="tt-icon tt-icon-right-arrow" />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  dates: makeSelectDatesByEventId((props) => props.event.id),
  org: makeSelectCurOrg(),
});

const enhance = flowRight(connect(mapStateToProps));

export default enhance(EventCardItem);
